<template>
  <div class="defaultDiv">
    <comerr :err="err"></comerr>
  </div>
</template>
<script>
import comerr from "../../components/tips/comerr";
export default {
  props: {},
  data() {
    return { err: "" };
  },
  watch: {},
  components: {
    comerr
  },
  async mounted() {},
  methods: {},
  created() {
    this.err = this.$route.query.err;
  }
};
</script>
<style lang="less" scoped>
.defaultDiv {
  top: 50%;
  position: absolute;
  left: 50%;
  transform: translate(-50%, -50%);
}
</style>
